import "./Footerpage.css";
import logo from "../img/niranlogo.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
/*
  Footer.jsx  — Section 8 (Home / Global)
  -----------------------------------------
  No props needed — purely content-driven.

  Usage:
    import Footer from "./Footer";
    <Footer />
*/

export default function Footer() {
  const navigate = useNavigate();
const { t } = useTranslation();
  return (
    <>
      <footer className="niran-footer">
        <div className="niran-footer__top">
          {/* Brand */}
          <div>
            <p className="niran-footer__brand-logo">
              <img src={logo} alt="Niranmatrimony Logo" />
            </p>
            <p className="niran-footer__brand-desc">
              {t("footer_tagline")}
            </p>
          </div>

          {/* Explore */}
          <div>
            <p className="niran-footer__col-title">{t("explore")}</p>
            <ul className="niran-footer__links">
              {[
                { name: t("home"), path: "/" },
                { name: t("success_stories"), path: "/successstories" },
                { name: t("featured_profiles"), path: "/matches" },
                { name: t("pricing_plans"), path: "/pricing" },
              ].map((item) => (
                <li key={item.name}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(item.path);
                    }}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <p className="niran-footer__col-title">{t("company")}</p>
            <ul className="niran-footer__links">
              {[
                { name: t("about_us"), path: "/about" },
                { name: t("contact_support"), path: "/contact" },
              ].map((item) => (
                <li key={item.name}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(item.path);
                    }}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <p className="niran-footer__col-title">{t("legal")}</p>
            <ul className="niran-footer__links">
              {[
                { name: t("privacy_policy"), path: "/privacypolicy" },
                { name: t("terms_and_condition"), path: "/termsandcondition" },
                // { name: t("cookie_policy"), path: "/cookie-policy" },
                // {
                //   name: t("trust_safety"),
                //   path: "/trust-and-safety-guidelines",
                // },
              ].map((item) => (
                <li key={item.name}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(item.path);
                    }}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <hr className="niran-footer__divider" />

        <div className="niran-footer__bottom">
          <p className="niran-footer__copy">
            © {new Date().getFullYear()} Niran Matrimony. All rights reserved.
          </p>

          <div className="niran-footer__socials">
            {/* Instagram */}
            <button className="niran-footer__social-btn" aria-label="Instagram">
              <svg viewBox="0 0 24 24">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <circle cx="12" cy="12" r="4" />
                <circle
                  cx="17.5"
                  cy="6.5"
                  r="0.5"
                  fill="currentColor"
                  stroke="none"
                />
              </svg>
            </button>

            {/* Facebook */}
            <button className="niran-footer__social-btn" aria-label="Facebook">
              <svg viewBox="0 0 24 24">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </button>

            {/* Twitter / X */}
            <button className="niran-footer__social-btn" aria-label="Twitter">
              <svg viewBox="0 0 24 24">
                <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" />
              </svg>
            </button>
          </div>
        </div>
      </footer>
    </>
  );
}
